import React from "react";
import { connect } from "react-redux";
import {Route, Switch} from "react-router-dom";
import {FormattedMessage} from "react-intl";

import WithCanvasImage from "../hocs/withCanvasImage";
import MaterialSpinner from "../../ui/materialSpinner";
import {ROUTES} from "../../../routes";

const LookUserLeftSide = () => {

  return (
    <WithCanvasImage>
      {(canvasSrc) => (
        <div className="ll-user__left">
          <div className="ll-user__left-content">
            <figure className="ll-figure">
              <div className="ll-preview ll-preview--big ll-figure__background"/>
              <div className="ll-preview ll-preview--big">
                {canvasSrc
                  ? <img src={canvasSrc} alt="" className="ll-preview__image"/>
                  : <MaterialSpinner/>}
              </div>
            </figure>
            <Switch>
              <Route path={ROUTES.register}>
                <h2 className="h2">
                  <FormattedMessage id="look.register.subTitle"/>
                </h2>
                <p className="text">
                  <FormattedMessage id="look.register.description"/>
                </p>
              </Route>
            </Switch>
          </div>
        </div>
      )}
    </WithCanvasImage>
  )
};

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(LookUserLeftSide)
